import { createPortal } from 'react-dom'
import { useOverlayScrollLock } from '../hooks/useOverlayScrollLock'
import { useEffect, type PropsWithChildren } from 'react'
import { SlidersHorizontal, X } from 'lucide-react'
import { protegerAposFechamentoPorToque } from '../utils/touchInteractionGuard'

type Props = PropsWithChildren<{
  aberto: boolean
  titulo?: string
  onClose: () => void
  onApply: () => void
  onClear: () => void
}>

export default function MobileFilterSheet({ aberto, titulo='Filtros', onClose, onApply, onClear, children }: Props) {
  useOverlayScrollLock(aberto)
  useEffect(() => {
    if (!aberto) return
    const esc=(event:KeyboardEvent)=>{ if(event.key==='Escape') onClose() }
    window.addEventListener('keydown',esc)
    return()=>{ window.removeEventListener('keydown',esc) }
  }, [aberto,onClose])

  if(!aberto)return null

  return createPortal(<>
    <button className="mobile-sheet-overlay" aria-label="Fechar filtros" onClick={(event)=>{event.preventDefault();event.stopPropagation();protegerAposFechamentoPorToque(event.detail);onClose()}}/>
    <section className="mobile-action-sheet mobile-filter-sheet" role="dialog" aria-modal="true" aria-label={titulo}>
      <div className="mobile-sheet-handle"/>
      <div className="mobile-sheet-header">
        <div><strong>{titulo}</strong><span>Refine o que deseja ver</span></div>
        <button className="mobile-sheet-close" onClick={(event)=>{event.preventDefault();event.stopPropagation();protegerAposFechamentoPorToque(event.detail);onClose()}} aria-label="Fechar"><X size={20}/></button>
      </div>
      <div className="mobile-filter-sheet-body">{children}</div>
      <div className="mobile-filter-sheet-actions">
        <button type="button" className="button ghost" onClick={onClear}>Limpar</button>
        <button type="button" className="button primary" onClick={onApply}><SlidersHorizontal size={16}/> Aplicar filtros</button>
      </div>
    </section>
  </>, document.body)
}

